import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
// import { eventsThisMonth } from '../../test.data';
import Button from '../button/v2/button';
import DropdownButton, { DROPDOWN_MENU } from '../button/v2/dropdown.button';

export function ProfileOptionsDropdown({ username }: { username: string }) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Button color="base-200" size="sm" asIcon="dots" withButtonStyle />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        sideOffset={0}
        align="center"
        className="bg-[#121212] py-2 px-1 rounded-lg shadow-feed"
      >
        <DropdownMenu.Item className={DROPDOWN_MENU.item}>
          <DropdownButton icon="mute" text={`Mute ${username}`} />
        </DropdownMenu.Item>
        <DropdownMenu.Item className={DROPDOWN_MENU.item}>
          <DropdownButton icon="flag" text="Report" />
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
